import mukwae from "../images/mukwae.png";
import julia from "../images/julia.png";
import mwape from "../images/mwape.png";
import mwenya from "../images/mwenya.png";
import loongo from "../images/loongo.png";
import lueji from "../images/lueji.png";
import headrest from "../images/artifacts/headrest.png";
import calabash from "../images/artifacts/calabash.png";
import cowry from "../images/artifacts/cowry.png";
import drum from "../images/artifacts/drum.png";
import mask from "../images/artifacts/mask.png";
import snuffCup from "../images/artifacts/snuffCup.png";

export const womenInfo = [
  {
    id: "julia-chikamoneka",
    name: "Julia Chikamoneka",
    image: julia,
    subText: "The fierce activist and pioneer of freedom from colonial rule",
    lived: "(1910 - 1986)",
    bioText:
      "Julia Mulenga ‘Chikamoneka’ was born Mary Nsofwa Lombe between 1904 and 1910 in Kasama Northern Zambi. She was the daughter of Mulenga Lombe son of Chief Chitimukulu-Ponde, who served as an African sergeant during the First world war.",
    ytLink: "https://www.youtube.com/watch?v=Ytc_wKNzows",
    artifactImg: headrest,
    artifactName: "THE HEADREST",
    artifactInfo:
      "Made from one block of wood, with a support on top that has a depression to hold the neck of a sleeping person. The head rest has decorations made by chipping out pieces of wood, completely cut out of wood pieces and also engravings in the wood. The headrest is supported by two pieces of wood that are shaped like two half kneeling legs. Base of the head rests burnt in black as a way of treating the wood.",
  },
  {
    id: "mukwae",
    name: "Mukwae",
    image: mukwae,
    subText: "The secretary of state for the Nalolo western province",
    lived: "(1910 - 1986)",
    bioText:
      "The Mukwae Nalolo governed a province of the Barotse Kingdom of Nalolo. She also maintained a dignity second only to the Litunga, who was the King.",
    ytLink: "https://www.youtube.com/watch?v=VwOAMAnLJQw",
    artifactImg: calabash,
    artifactName: "CALABASH",
    artifactInfo:
      "Made from gourd, upper part decorated with engravings, braising, and chip offs darkened by burning. Lower part knitted with  fibres. The fibres are used for carrying as a handle but also a grip for the slippery nature of the gourd.",
  },
  {
    id: "mwape",
    name: "Mwape",
    image: mwape,
    subText:
      "A fearless warrior and ruler of middle Luangwa and Chuambira valley",
    lived: "(1910 - 1986)",
    bioText:
      "She was a ruler of a Kingdom that comprised the middle Luangwa and the Chuambira valley and further east, Mulilo, and Chisenga respectively at Chinshumbu and Kaundi who owed her allegiance.",
    ytLink: "https://www.youtube.com/watch?v=VjXktuYSgfQ&t=9s",
    artifactImg: cowry,
    artifactName: "COWRY BELT",
    artifactInfo:
      "A belt made of leather and cowry shells. Cowries were expensive in places far away from the sea like Zambia and could only be acquired by people of influence. To possess such an item with such a large number of cowries meant the person that owned this belt was very wealthy. The shells were also used as a medium of exchange and are also an indicator of the presence of long distance trade in the interior of Zambia.",
  },
  {
    id: "mwenya",
    name: "Mwenya",
    image: mwenya,
    subText: "Known as the 17th century Diplomat",
    lived: "(1910 - 1986)",
    bioText:
      "Mwenya Mukulu was the leader of the Lungu, Azamba, Azao or Sao people. The Lungu or Azamba people came down the lake in canoes from the eastern side of Lake Tanganyika at the end of the 17th century.",
    ytLink: "https://www.youtube.com/watch?v=xzCoP4NEbTg",
    artifactImg: drum,
    artifactName: "DOUBLE SIDED DRUM",
    artifactInfo:
      "A royal drum made out of wood, fibres, and python skin and decorated in black colour. It was used when the chief is coming to or leaving a meeting",
  },
  {
    id: "loongo",
    name: "Loongo",
    image: loongo,
    subText: "The Warrior Queen of the Sala people",
    lived: "(1910 - 1986)",
    bioText:
      "She ruled the Sala people of the Mumbwa area. She was the current ruler of the Sala people when the Makololo invaded her land.",
    ytLink: "https://www.youtube.com/watch?v=_wQ21pmFYZY",
    artifactImg: mask,
    artifactName: "HEAD MASK",
    artifactInfo:
      "The mask of Mwanapewo used in the Makishi masquerade. It is a female Likishi in an all male mask squad. It represents beauty, fertility, and agility. During the Mukanda camp school, it provides the connection between the school, the village, and between the initiates and their mothers. It had tribal markings of the Luvale people that showed beauty and it also has sharpened teeth, this is because Luvale women used to file their teeth to look beautiful. However, the tribal markings and sharpening of teeth are no longer practiced.",
  },
  {
    id: "lueji-wa-nkonde",
    name: "Lueji wa Nkonde",
    image: lueji,
    subText: "The 17th Century Political Negotiator",
    lived: "(1910 - 1986)",
    bioText:
      "Lueji was the daughter of Mwata Iyala Mwaku, a descendant of Queen Kenga Naweji. Mwata Iyala Mwaku appointed Lueji wa Konde as his successor, or Nswana Mu Luunda.",
    ytLink: "https://www.youtube.com/watch?v=A1HEPtkt8P4",
    artifactImg: snuffCup,
    artifactName: "SNUFF CUP",
    artifactInfo:
      "Used to store and carry snuff (Tobacco). It has three openings: on both ends for loading the snuff. On one end It is closed with a wood stopper. Another small opening on the side of the container, for pouring out the snuff when one wants to use it. It is closed with an elaborate wood lid. The wood is burnt black and oiled (Traditional way of treating wood) and decorated with engravings.",
  },
];
